import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { UserModel } from '@app/data-layer/models/user';
import { AppLayoutService } from '@app/modules/app-layout/app-layout.service';
import { IHeaderItem } from '@app/modules/app-layout/interfaces';
import { CompaniesService } from '@services/companies.service';

@Component({
  selector: 'account-settings-billing-history-page',
  templateUrl: './account-settings-billing-history-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountSettingsBillingHistoryPageComponent implements OnInit {
  public currentUser: UserModel;
  public organizationId: number;

  constructor(private appLayoutService: AppLayoutService, private companiesService: CompaniesService) {}

  ngOnInit() {
    this.currentUser = this.companiesService.getUser();
    const firstCompany = this.companiesService.getCompanies()[0];

    this.organizationId = this.currentUser.defaultOrganizationId || firstCompany.organizationId;

    const title: IHeaderItem[] = [];
    title.push(
      {
        key: 'MENU.ACCOUNT_SETTINGS',
        link: '/companies/account-settings',
      },
      { key: 'MENU.BILLING_HISTORY', link: null },
    );
    this.appLayoutService.contentHeader$.next({ title, mobileTitle: title });
  }
}
